<template>
    <section>
        <mvtCollapse :disable="disableCollapse" :isActive="isActive">
            <template v-slot:header="collapsible">
                <h2 class="f4 text-bold singleline">{{ estTitle }}</h2>
                <div class="f7 text-gray singleline property-estimate-subtitle" v-if="rangeText && !dpp.hideAvmAndRange" v-show="collapsible.collapsed">
                    {{molang('dpp.estimate')}}
                    <span v-if="dpp.permitAvm && estPrice && isListPriceHigher">{{$filters.formatFriendlyPrice(estPrice)}}</span>
                    <span v-if="rangeText">{{molang('dpp.range')}} {{rangeText}}</span>
                    <span v-if="!dpp.permitAvm && estAreaPrice">{{molang('dpp.average')}} {{$filters.formatPricePerArea(estAreaPrice, dpp.isLand)}}{{dpp.isLand ? '/Acre' : '/Sqft'}}</span>
                </div>
            </template>
            <template v-slot:default>
                <mvtClientOnly>
                    <div class="grid xs-grid-cols-1">
                        <div class="inline bg-default corner grid xs-grid-cols-1 outline" v-if="dpp.permitAvm && getEstRentFee">
                            <div>
                                <div class="flex">
                                    <span class="text-bold f6">Rental Estimate</span>
                                    <a @click="openAvmDisclaimer3" role="button"><i class="icon-Info-Circle"></i></a>
                                </div>
                                <div>
                                    <div>
                                        <div class="text-bold f4">{{ $filters.formatPrice(getEstRentFee.value) }}/Month</div>
                                    </div>
                                    <div class="f7" v-if="getEstRentFee.grm>0">
                                        <a @click="openAvmDisclaimer4" role="button">Gross Rent Multiplier</a>: {{ getEstRentFee.grm }} {{ getEstRentFee.rate ? '- ' + getEstRentFee.rate : '' }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <mvtEstPrice :isMarket5YLoaded="isMarket5YLoaded" :dpp="dpp" :showPriceEst="dpp.permitAvm" :showAVM="dpp.avmInfo && !(dpp.listingByMovoto && dpp.avmInfo.valuation < dpp.listPrice)"></mvtEstPrice>

                        <dppCtaCard v-if="dpp.isActive" :dppCtaInfo="{title: molang('dpp.propertyEstimate.ctaTitle'),
                                sub: molang('dpp.propertyEstimate.ctaSub'), icon: 'icon-money',
                                cta: molang('dpp.sellbanner.connectNow'), hotleadType: 'HomevalueDPP',
                                section: 'Home Value and Comps'}"
                        />
                        <div class="paragraph f7" v-if="showNotSupportedByMLS()">
                            {{ molang('dpp.movotoPowered') }}
                        </div>
                    </div>
                </mvtClientOnly>
            </template>
        </mvtCollapse>
    </section>
</template>
<script src="./property-estimate.js"></script>

<style lang="scss">
@use "./property-estimate.scss" as *;
</style>
